export enum SellerCommunicationStatus {
	DEALER_MARKED_AS_CONTACTED = 'DEALER_MARKED_AS_CONTACTED',
	FAILED_TO_CREATE_MESSAGE = 'FAILED_TO_CREATE_MESSAGE',
	MESSAGE_CREATION_IS_PENDING = 'MESSAGE_CREATION_IS_PENDING',
	MESSAGE_HAS_BEEN_CREATED = 'MESSAGE_HAS_BEEN_CREATED',
	NO_MESSAGE_HAS_BEEN_CREATED = 'NO_MESSAGE_HAS_BEEN_CREATED',
	SALE_CANCELLED = 'SALE_CANCELLED',
}
